import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faWandMagicSparkles } from "@fortawesome/pro-solid-svg-icons";
import { faHouse } from "@fortawesome/pro-regular-svg-icons";


import Card from "@/components/card/index.tsx";
import ProjectEditButton from "@/components/buttons/project-edit-button";

interface Calcul1PdfsimpleCardActionProps {
    storeysFileDataHasScale: boolean;
    hasMetresDepuisCalcul: boolean;
    isLoading: boolean;
    onClick: () => void;
}

const Calcul1PdfsimpleCardAction: React.FC<Calcul1PdfsimpleCardActionProps> = ({
    storeysFileDataHasScale,
    hasMetresDepuisCalcul,
    isLoading,
    onClick
}) => 
    (
        <>
            <Card additionalContentClasses='flex flex-col gap-y-2 px-4 py-2 text-sm'>
                <ProjectEditButton variant='simple' size='sm'
                    onClick={onClick}
                    disabled={isLoading || !storeysFileDataHasScale}>
                    <div className='flex flex-row gap-x-2 items-center'>
                        <div className='flex flex-row gap-x-1 items-baseline'>
                            <FontAwesomeIcon icon={faHouse} />
                            <FontAwesomeIcon icon={faWandMagicSparkles} />

                            {hasMetresDepuisCalcul &&
                                <FontAwesomeIcon icon={faCheck} className='text-green-500' />
                            }
                        </div>
                        <span>Calcul automatique</span>
                    </div>
                </ProjectEditButton>

                <div>
                    <span>Obtenez automatiquement</span>
                    <ul className='list-disc list-inside pl-2 text-sm'>
                        <li>Murs intérieurs</li>
                        <li>Murs extérieurs</li>
                        <li>Dalles</li>
                        <li>Pièces gros-œuvre</li>
                    </ul>
                </div>
            </Card>
        </>
    );

export default Calcul1PdfsimpleCardAction;